module.exports = "/assets/89e03e1e6d22bd417a96f0dca541dc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PE.png
// module id = 2837
// module chunks = 0